// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1DbOr{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}._3sc3e{padding:1.375rem 0}._3sc3e+._3sc3e{border-top:1px solid #dcdddd}._29ePu{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;cursor:pointer}.KlHXu{-ms-flex:1 1;flex:1 1;font-size:16px;font-weight:400;line-height:26px;font-family:var(--base-font)}._3XvaI{max-width:0;opacity:0}._3XvaI,.MuuAg{-webkit-transition:opacity .3s cubic-bezier(.23,1,.32,1);-o-transition:opacity .3s cubic-bezier(.23,1,.32,1);transition:opacity .3s cubic-bezier(.23,1,.32,1)}.MuuAg{opacity:1}._3Z1Xn{overflow:hidden;-webkit-transition:all .3s cubic-bezier(.645,.045,.355,1);-o-transition:all .3s cubic-bezier(.645,.045,.355,1);transition:all .3s cubic-bezier(.645,.045,.355,1);-webkit-transition-property:padding,max-height;-o-transition-property:padding,max-height;transition-property:padding,max-height;color:#595757;max-height:0;font-size:16px;font-weight:300;line-height:26px;font-family:var(--base-font)}._2pJg6 .MuuAg{opacity:0;max-width:0}._2pJg6 ._3XvaI{opacity:1;max-width:unset}._2pJg6 ._3Z1Xn{max-height:inherit;padding-top:1rem}", ""]);
// Exports
exports.locals = {
	"NAVBAR_HEIGHT": "72",
	"TABLET_WIDTH": "768",
	"DESKTOP_WIDTH": "1024",
	"WIDE_DESKTOP_WIDTH": "1440",
	"root": "_1DbOr",
	"item": "_3sc3e",
	"header": "_29ePu",
	"label": "KlHXu",
	"collapseIcon": "_3XvaI",
	"expandIcon": "MuuAg",
	"content": "_3Z1Xn",
	"active": "_2pJg6"
};
module.exports = exports;
